import PrincipalVisualizationPart2 from './PrincipalVisualizationPart2';


export default PrincipalVisualizationPart2;